// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2Rvc9","left":"StickyBox_left__3myhe","right":"StickyBox_right__1R_S4"};